import { useState } from "react";
import "./stlye.css";
import "./mobileStyle.css";
import Instagram from "../../../../images/instagram2.png";
import Info from "../../../../images/info.svg";

function TrainerCard(props: any) {
  const { pictureName, name, instagram, isDesktop, trainerDescription } = props;

  const [showInfo, setShowInfo] = useState(false);

  return (
    <div
      onBlur={() => setShowInfo(false)}
      style={{ background: "white" }}
      className={isDesktop ? "TrainerCard" : "MobileTrainerCard"}
    >
      {showInfo ? (
        <div className="trainer-info" style={{ fontSize: "20px" }}>
          <div>
            <div>
              <button
                onClick={() => setShowInfo(false)}
                style={{
                  height: "30px",
                  width: "30px",
                  borderRadius: "30px",
                  border: "none",
                  cursor: "pointer",
                  background: "white",
                  fontSize: "20px",
                }}
              >
                X
              </button>
            </div>
            <pre
              style={{
                whiteSpace: "pre-wrap",
              }}
            >
              {trainerDescription}
            </pre>
          </div>
        </div>
      ) : (
        <>
          <div
            className="image"
            style={{ backgroundImage: `url(${pictureName})` }}
          ></div>
          <div className="overlay"></div>
          <div className="icons">
            {instagram ? (
              <a
                href={`https://instagram.com/${instagram}`}
                className="icon"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Instagram as unknown as string} alt="instalogo" />
              </a>
            ) : null}
            <div className="icon" onClick={() => setShowInfo(true)}>
              <img alt="" src={Info} />
            </div>
          </div>
        </>
      )}
      <div className="name-box">
        <div className="titles">{name}</div>
      </div>
    </div>
  );
}
export default TrainerCard;
